import React from "react";
import { Stack, Text } from "@mantine/core";
import { MetricInfo } from "../../common/InfoTooltip";
import { ReportMetricDef } from "../../../types/reportsV2";

export interface MetricTooltipProps {
  metric: ReportMetricDef;
}

/** True when a metric has anything to say in a tooltip. */
export const hasMetricHelp = (metric: ReportMetricDef): boolean =>
  !!(
    metric.description ||
    metric.formula ||
    (!metric.available && metric.unavailable_reason)
  );

/**
 * Tooltip body for a report metric: why it's unavailable (when it is), then
 * its description and formula — all verbatim from the report definition.
 */
export default function MetricTooltip({ metric }: MetricTooltipProps) {
  const reason = !metric.available ? metric.unavailable_reason : null;
  return (
    <Stack gap={6}>
      {reason && (
        <Text component="span" fz="xs" fw={600}>
          {reason}
        </Text>
      )}
      <MetricInfo description={metric.description} formula={metric.formula} />
    </Stack>
  );
}
